import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MmButtonModule, MmDialogModule, MmAlertModule, MmIconModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';

import { AdvancedFormModule } from '~shared/modules/advanced-form/advanced-form.module';
import { MediaControlModule } from '~shared/modules/media-control/media-control.module';

import { AccountInfoComponent } from './components/account-info/account-info.component';
import { AccountDetailsComponent } from './components/account-details/account-details.component';
import { AddBusinessInfoComponent } from './components/add-business-info/add-business-info.component';
import { EditBusinessInfoComponent } from './components/edit-business-info/edit-business-info.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ChangeEmailComponent } from './components/change-email/change-email.component';
import { EditPrivateInfoComponent } from './components/edit-private-info/edit-private-info.component';
import {
  BusinessInfoCancellationComponent
} from './components/business-info-cancellation/business-info-cancellation.component';
import {
  ExpiredChangeEmailRequestComponent
} from './components/expired-change-email-request/expired-change-email-request.component';
import { AccountManagementDataService } from './services/account-management-data.service';
import { EntrepreneurStatusGuard } from './guards/entrepreneur-status.guard';
import { BusinessInfoCancellationGuard } from './guards/business-info-cancellation.guard';
import { AccountManagementHttpService } from './services/account-management-http.service';
import { AccountManagementService } from './services/account-management.service';
import { ExpiredChangeEmailRequestService } from './services/expired-change-email-request.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    MmIconModule,
    MmAlertModule,
    MmDialogModule,
    MmButtonModule,
    QaLocatorsModule,
    AdvancedFormModule,
    MediaControlModule,
  ],
  declarations: [
    ChangeEmailComponent,
    AccountInfoComponent,
    AddBusinessInfoComponent,
    EditBusinessInfoComponent,
    ChangePasswordComponent,
    EditPrivateInfoComponent,
    AccountDetailsComponent,
    BusinessInfoCancellationComponent,
    ExpiredChangeEmailRequestComponent,
  ],
  providers: [
    AccountManagementDataService,
    AccountManagementService,
    AccountManagementHttpService,
    ExpiredChangeEmailRequestService,
    EntrepreneurStatusGuard,
    BusinessInfoCancellationGuard,
  ]
})
export class AccountManagementModule {}
